import { BaseApi } from '@/main/baseApi';

import { DMS_MODULE, NAME } from './constants';

class NationalAccount extends BaseApi {
	saveNationalAccountData(dto: any) { return this.post(`/${DMS_MODULE}/${NAME}/SaveNationalCustomerAccount`, dto); }
	deleteNationalAccountData(id: any) { return this.delete(`/${DMS_MODULE}/${NAME}/DeleteNationalCustomerAccount?Id=${id}`); }
}
export const apiProvider = new NationalAccount(DMS_MODULE, NAME);
